import { useSalesStore } from '@/store/sales';

export const expensesOptions = {
  searchSales: async (query: string | Record<string, any> = '') => {
    const store = useSalesStore();
    await store.searchSales(query);
    return store.sales_search;
  },
};
